import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

import { SessionService } from '../shared';

ng.module('e360').run(missingBrandCampaignHook);

/**
 * This transition hook catches cases when a user has deleted a brand
 * or campaign. They are restricted to the org/brand/campaign add/edit
 * states until the missing records are resolved OR a different campaign
 * is selected using the dropdowns.
 */
missingBrandCampaignHook.$inject = ['$transitions', 'session'];
function missingBrandCampaignHook($transitions:uir.TransitionService, session:SessionService) {
   $transitions.onBefore({to: requiresBrand}, redirectAddBrand);
   $transitions.onBefore({to: requiresCampaign}, redirectAddCampaign);

   function requiresBrand(state:uir.StateObject) {
      if (session.isLoggedIn()
         && session.getOrg()
         && !session.getBrand()
         && ['addBrand', 'orgAdd', 'orgEdit'].indexOf(state.name) == -1
      ) {
         return true;
      }

      return false;
   }

   function requiresCampaign(state:uir.StateObject) {
      if (session.isLoggedIn()
         && session.getBrand()
         && !session.getCampaign()
         && ['campaign.add', 'addBrand', 'editBrand', 'orgAdd', 'orgEdit'].indexOf(state.name) == -1
      ) {
         return true;
      }

      return false;
   }

   function redirectAddBrand(transition:uir.Transition) {
      return transition.router.stateService.target('addBrand');
   }

   function redirectAddCampaign(transition:uir.Transition) {
      return transition.router.stateService.target('campaign.add');
   }
}
